export const fetchServiceLevelSpecialtiesData = async () => {
  try {
      const headers = new Headers({
          "cache-control": "max-age=172800"
      })
    const response = await fetch('./content/ship/page-components/article/service-levels-bottom-tiles.json', {
        headers: headers
    });
    return await response.json();
  } catch (e) {
    console.log(e)
  }
};



// WEBPACK FOOTER //
// ./src/api/fetchServiceLevelSpecialtiesData.js